import React from 'react';
import './input.css';

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  className?: string;
};

const Input: React.FC<InputProps> = ({
  label,
  className = '',
  autoComplete = 'off',
  ...props
}) => {
  return (
    <label className="input-label">
      {label && <span className="input-label-text">{label}</span>}
      <input
        className={`input-element ${className}`}
        autoComplete={autoComplete}
        {...props}
      />
    </label>
  );
}

export default Input;